import type { CSSProperties } from 'react'

export interface HeatmapProps {
  readonly rows: readonly string[]
  readonly cols: readonly string[]
  readonly data: readonly (readonly number[])[]
  readonly max: number
  readonly colorScale?: (value: number, max: number) => string
}

function defaultScale(value: number, max: number): string {
  const ratio = Math.max(0, Math.min(1, value / max))
  return `color-mix(in srgb, var(--brand) ${Math.round(8 + ratio * 84)}%, transparent)`
}

export function Heatmap({ rows, cols, data, max, colorScale = defaultScale }: HeatmapProps) {
  return (
    <div style={{ display: 'grid', gridTemplateColumns: `auto repeat(${cols.length}, 1fr)`, gap: 3 }}>
      <div />
      {cols.map((column) => (
        <div key={column} style={{ fontFamily: 'var(--font-mono)', fontSize: 10, color: 'var(--fg-muted)', textAlign: 'center' }}>
          {column}
        </div>
      ))}
      {rows.map((row, rowIndex) => (
        <div key={row} style={{ display: 'contents' }}>
          <div style={{ fontSize: 12, color: 'var(--fg-2)', paddingRight: 8, display: 'flex', alignItems: 'center' }}>{row}</div>
          {data[rowIndex]!.map((value, colIndex) => (
            <div
              key={`${rowIndex}-${colIndex}`}
              title={`${row} · ${cols[colIndex]}: ${value}`}
              style={
                {
                  background: colorScale(value, max),
                  borderRadius: 3,
                  aspectRatio: '1.2 / 1',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontFamily: 'var(--font-mono)',
                  fontSize: 10,
                  color: value / max > 0.5 ? 'var(--fg-on-mauve)' : 'var(--fg-2)',
                } as CSSProperties
              }
            >
              {value > 0 ? value : ''}
            </div>
          ))}
        </div>
      ))}
    </div>
  )
}
